// extracted by mini-css-extract-plugin
export default {"mainLayoutWrapper":"main-layout_mainLayoutWrapper__80vC7"};